import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/it';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt';
import 'dayjs/locale/zh-cn';

import CookiesConstants from 'ha/constants/Cookies';

import { Thunk } from 'ha/myredux/types';
import { Locale } from '@ha/intl';
import fetchUser from './fetchUser';
import fetchImpersonationInfo from './fetchImpersonationInfo';
import impersonateUser from './impersonateUser';
import { getIsLoaded, getIsAdmin, getUser } from '../selectors';
import { conversationAccessFeature } from '../constants';

const IMPERSONATION_QUERY_PARAMETER = 'id2';

function initSession(lang: string): Thunk {
  return async (dispatch, getState, { cookie, apiV2 }) => {
    const localeFromLanguage = Locale[lang];

    dayjs.locale(localeFromLanguage);

    const isLoaded = getIsLoaded(getState());

    if (!isLoaded) {
      await dispatch(fetchUser());
    }

    if (process.browser && typeof global.Txt !== 'undefined') {
      const user = getUser(getState());

      const userType = user ? user?.type || 'tenant' : 'anonymous';

      let subscriptionType = 'N/A';

      if (user && userType === 'tenant') {
        const {
          data: { subscriptions },
        } = await apiV2.getSubscriptions({ userId: user.id });

        const activeStates = [
          'active',
          'trialing',
          'unpaid',
          'past_due',
          'canceled',
        ];

        const activeSubscription = subscriptions.find(
          sub =>
            activeStates.includes(sub.state) &&
            Boolean(
              sub.items.find(item =>
                item.features.includes(conversationAccessFeature),
              ),
            ),
        );

        subscriptionType = activeSubscription ? 'active' : 'inactive';
      }

      const userData = [
        {
          key: 'userType',
          value: userType,
          type: 'string',
          custom: true,
        },
        {
          key: 'subscriptionType',
          value: subscriptionType,
          type: 'string',
          custom: true,
        },
      ];
      if (user) {
        global.Txt.identify(
          `${user.uuid}@user.housinganywhere.com`,
          userData,
          user.uuid,
        );
      } else {
        global.Txt.updateProfile(userData);
      }
    }

    const isAdmin = getIsAdmin(getState());

    if (isAdmin) {
      cookie.setCookie(CookiesConstants.PWA_NEXT_ENABLED, '1', {
        // Server lib doesn't support numbers as expires value
        expires: new Date(new Date().valueOf() * 1 + 30 * 864e5),
      });
    }

    if (process.browser) {
      if (isAdmin) {
        const urlObject = new URL(window.location.href);

        const impersonationTargetUserId = urlObject.searchParams.get(
          IMPERSONATION_QUERY_PARAMETER,
        );

        if (impersonationTargetUserId) {
          urlObject.searchParams.delete(IMPERSONATION_QUERY_PARAMETER);

          await dispatch(
            impersonateUser(
              parseInt(impersonationTargetUserId, 10),
              urlObject.toString(),
            ),
          );
        } else {
          await dispatch(fetchImpersonationInfo());
        }
      } else {
        await dispatch(fetchImpersonationInfo());
      }
    }
  };
}

export default initSession;
